import { useQuery } from 'react-query';
import { weekCommitmentService } from '../../../../services';

export const useGetWeeklyPlanByNumber = ({
  projectId,
  scheduleId,
  wwpNumber,
  defaultWWPNumber,
  isDefaultWWPAvailable
}) => {
  const shouldFetchWeeklyPlan = () => {
    if (wwpNumber === defaultWWPNumber && !isDefaultWWPAvailable) {
      return false;
    }
    return Boolean(wwpNumber);
  };

  const { data, isLoading, isError } = useQuery({
    queryKey: ['weeklyPlanByNumber', { projectId, scheduleId, wwpNumber }],
    queryFn: async () => {
      const response = await weekCommitmentService.getWeeklyPlanByNumber({
        projectId,
        scheduleId,
        number: wwpNumber
      });
      return response;
    },
    enabled: shouldFetchWeeklyPlan(),
    retry: false
  });

  return {
    data,
    isLoading,
    isError
  };
};
